"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.21.0
 */
'use client';

import { jsxs, jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { clsx } from 'clsx';
import '../../../styled-system/css/css.mjs';
import '../../../styled-system/helpers.mjs';
import { sva } from '../../../styled-system/css/sva.mjs';

const fieldNameInputRecipe = sva({
  className: "field-name-input",
  slots: ["wrapper", "input", "span"],
  base: {
    wrapper: {
      display: "inline-block",
      cursor: "default",
      position: "relative",
      _hover: {
        "& .span": {
          visibility: "hidden"
        },
        "& .input": {
          visibility: "visible"
        }
      }
    },
    span: {
      display: "block",
      visibility: "visible",
      _empty: {
        _after: {
          color: "gray.9",
          content: "var(--placeholder-text)"
        }
      }
    },
    input: {
      position: "absolute",
      inset: "0",
      w: "full",
      transitionProperty: "colors",
      p: "0",
      m: "0",
      borderTopColor: "transparent",
      opacity: "0",
      _hover: {
        opacity: "1"
      },
      _focus: {
        opacity: "1",
        outline: "none",
        "& + .span": {
          visibility: "hidden"
        }
      }
    }
  }
});
const fieldNameInputClassNames = fieldNameInputRecipe();
function FieldNameInput({
  value,
  className,
  placeholder = "Enter some text",
  onChange = () => {
  },
  onEnter = () => {
  },
  onEsc = () => {
  },
  onFocus = () => {
  },
  onBlur = () => {
  },
  editable = true,
  autoFocus = false,
  ...props
}) {
  const handleChange = (event) => {
    onChange(event.target.value);
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.currentTarget.blur();
      onEnter?.(value);
      return;
    }
    if (event.key === "Escape") {
      event.currentTarget.blur();
      onEsc?.(value);
      return;
    }
  };
  const handleFocus = (event) => {
    onFocus(event.target.value);
  };
  const handleBlur = (event) => {
    onChange(event.target.value);
    onBlur(event.target.value);
  };
  const style = useMemo(
    () => ({
      "--placeholder-text": `"${placeholder}"`
    }),
    [placeholder]
  );
  const classNames = clsx(fieldNameInputClassNames.wrapper, className);
  return /* @__PURE__ */ jsxs("span", { className: classNames, ...props, title: value, children: [
    /* @__PURE__ */ jsx(
      "input",
      {
        className: fieldNameInputClassNames.input,
        onChange: handleChange,
        value,
        placeholder,
        "aria-label": placeholder,
        readOnly: !editable,
        autoFocus,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown
      }
    ),
    /* @__PURE__ */ jsx("span", { className: fieldNameInputClassNames.span, style, children: value?.replace(/\s/g, "\xA0") })
  ] });
}

export { FieldNameInput };
